// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2e09l","inputWrap":"CustomTip_inputWrap__3wcKb"};